// PATH: src/pages/CuerpoPastoral.jsx
// VERSION: 3.0 — Fetch /api/ministry (title + members)
import React, { useEffect, useState } from 'react';
import { Box, Image, Heading, Text, VStack, SimpleGrid, Container, Alert, AlertIcon, Spinner, Flex } from '@chakra-ui/react';
import { cld } from '../utils/cloudinary';

const API = process.env.REACT_APP_API_BASE_URL || '/api';

export default function Ministerio() {
  const [title, setTitle] = useState('Ministerio');
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let alive = true;
    async function load() {
      setLoading(true);
      setErr(null);
      try {
        const r = await fetch(`${API}/ministry`);
        const j = await r.json();
        if (!r.ok || j.ok === false) throw new Error(j.error || 'error');
        if (alive) {
          setTitle(j.title || 'Ministerio');
          setMembers(Array.isArray(j.members) ? j.members : []);
        }
      } catch (e) {
        if (alive) setErr('No se pudo cargar el ministerio.');
      } finally {
        if (alive) setLoading(false);
      }
    }
    load();
    return () => { alive = false; };
  }, []);

  return (
    <Box bg="bg.default" flex="1">
      <Container maxW="container.xl" py={{ base: 8, md: 12 }}>
        <Heading textAlign="center" mb={6} color="text.default">
          {title}
        </Heading>

        {err && <Alert status="error" mb={4}><AlertIcon />{err}</Alert>}

        {loading ? (
          <Flex justify="center" py={12}><Spinner size="lg" /></Flex>
        ) : (
          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8}>
            {members.map((m, i) => (
              <Box
                key={`${m.name}-${i}`}
                borderWidth="1px"
                borderRadius="lg"
                overflow="hidden"
                bg="bg.card"
                boxShadow="sm"
                transition="all .25s ease"
                _hover={{ transform: 'translateY(-4px)', boxShadow: 'md' }}
              >
                <Image
                  src={cld(m.photo, { w: 800, h: 600, crop: 'fill', gravity: 'auto' })}
                  alt={m.name}
                  w="100%"
                  h="300px"
                  objectFit="cover"
                  fallbackSrc="https://via.placeholder.com/600x400?text=Foto+no+cargada"
                />
                <VStack p={4} spacing={2} align="start">
                  <Heading size="md" color="text.default">{m.name}</Heading>
                  <Text fontWeight="bold" color="text.muted">
                    {m.position}{m.ministerio ? ` — ${m.ministerio}` : ''}
                  </Text>
                  {m.phrase && <Text color="text.muted" fontStyle="italic">"{m.phrase}"</Text>}
                </VStack>
              </Box>
            ))}
          </SimpleGrid>
        )}
      </Container>
    </Box>
  );
}
